const Data = [
  {
    id: "1",
    category: "Kids Section",
    image: "Bo_1",
    name: "Ethnic Wear Indo Western Kurta Dhoti Set",
    price: "999",
    description:
      "•	Specially handcrafted clothing for the perfect look and comfort for the festive season•	Premium Indian ethnic, festive and party wear for kids designed by AJ Dezines.•	Fabric Details :- Cotton Silk Fabric",
  },
  {
    id: "2",
    category: "Kids Section",
    image: "Bo_2",
    name: "Indo Western Sherwani Set",
    price: "1424",
    description:
      "•	Package Contents- Sherwani and Pant Set•	Fabric Details :- Cotton Blend || Style - Gentlemen Suit•	Specially handcrafted clothing for the perfect look and comfort for the festive season",
  },
  {
    id: "3",
    category: "Kids Section",
    image: "Bo_3",
    name: "Zolario 3 Piece Coat,Pant,shirt",
    price: "899",
    description:
      "•	EASILY WASH: Normal Hand or Machine Wash, No Need to Spent Your Hard Earned Money on Dry Cleaning.•	IMPORTANT: Latest Designer, Regular Size, Fine Printed, Good Quality Material But Please Buy as Per the Size Chart.",
  },
  {
    id: "4",
    category: "Kids Section",
    image: "Bo_4",
    name: "Ethnic Wear Handloom Cotton Solid Pattern Kurta with White Pyjama Set",
    price: "712",
    description:
      "•Care Instructions: Dry Clean Only • Fit Type: Regular •Comfortable in its make and breathable Aesthetic design Perfect for gifting",
  },
  {
    id: "5",
    category: "Kids Section",
    image: "Bo_5",
    name: "Ethnic Indo Western Sherwani Kurta and Dhoti Pant Set",
    price: "1499",
    description:
      "•	This traditional ethnic wear indo western/sherwani kurta with dhoti pant for kids and boys!•	Fabric detail: indo western/sherwani - brocade silk; kurta and dhoti pant -dupion silk. Sales package - 1 Indo western/sherwani; 1 kurta; 1 dhoti pants. Age group: 2 years to 11 years",
  },
  {
    id: "6",
    category: "Kids Section",
    image: "Bo_6",
    name: "HELLCAT Blended Cotton Polo Tshirt - Navy Blue",
    price: "399",
    description:
      "Colour: Navy Blue •	Care Instructions: Machine Wash•	Premium quality polo tshirt for kids boys",
  },

  {
    id: "7",
    category: "Kids Section",
    image: "Bo_7",
    name: "Jam & Honey T-Shirt",
    price: "553",
    description:
      "•	Care Instructions: Machine Wash•	Regular Length T-Shirt With Print.•	Combo Pack Of 3 T-Shirts For Boys•	100% Cotton Single Jersey T-Shirt •	Round Neck T-Shirt For Boy'S; Attractive Colors And Designs•	Closure Type: Pull On; Fit Type: Regular Fit",
  },
  {
    id: "8",
    category: "Kids Section",
    image: "Bo_8",
    name: "U.S. POLO ASSN. Shirt",
    price: "675",
    description: "•	Care Instructions: Machine Wash•	Cotton",
  },
  {
    id: "9",
    category: "Kids Section",
    image: "Bo_9",
    name: "Jam & Honey Button down Shirt",
    price: "474",
    description:
      "•	Care Instructions: Machine Wash•	Fit Type: Regular•	Material: Cotton  •	Closure: Button•	Fit type: Regular•	Style: Button Up•	Sleeve type: Long Sleeve",
  },
  {
    id: "10",
    category: "Kids Section",
    image: "Bo_10",
    name: "United Color of Benetton Shirt",
    price: "465",
    description:
      "•	Care Instructions: Machine Wash •	Fit Type: Regular•	100% COTTON",
  },
  {
    id: "11",
    category: "Kids Section",
    image: "Bo_11",
    name: "T2F Loose Track pants",
    price: "919",
    description:
      "•	Care Instructions: Machine Wash•	Fit Type: Regular•	Ideal for baby boys•	Pack includes: Pack of 5•	Colour: Multicolour",
  },
  {
    id: "12",
    category: "Kids Section",
    image: "Bo_12",
    name: "Cotton Joggers Track Pants",
    price: "499",
    description:
      "•	 Fit Type: Regular•	Material: Cotton, Fit Type: Regular Fit•	Full length Tarck pants•	Durable and Soft Fabric •	Proudly made in india",
  },
  {
    id: "13",
    category: "Kids Section",
    image: "Bo_13",
    name: "Ventra Cotton Checkered Pyjama",
    price: "599",
    description:
      "Care Instructions: Machine wash, Do Not Bleach, Do Not Dry Clean, Do Not Iron on the Print, Warm Iron if Needed•	100% Cotton Fabric for Soft and Comfortable wear•	Durable and Breathable fabric to be soft on Kids' skin•	Full Sleeves and Round Neck Top•	Elastic Waistband for comfortable fit",
  },
  {
    id: "14",
    category: "Kids Section",
    image: "Bo_14",
    name: "Cotton Printed Jogger Fashion Pants Grey",
    price: "999",
    description:
      "•	Care Instructions: Machine Wash•	Fit Type: Tapered Fit •	Check Measurement chart before placing order to avoid size fit issues •	Two Side Pockets •	Elasticated waist band with functional drawstring.",
  },
  {
    id: "15",
    category: "Kids Section",
    image: "Bo_15",
    name: "Cotton Berry Blue Color Jeans",
    price: "599",
    description:
      "•	Enhance your style statement•	Soft and comfy•	Trendy and stylish",
  },
  {
    id: "16",
    category: "Kids Section",
    image: "Bo_16",
    name: "JMFCHI SPORTS Shoes ",
    price: "487",
    description:
      "Sole: PVC || Closure : Lace-Up ||Color : Multicolor || Toe Style: Closed Toe. Elevate your style with this classy pair of Sports Shoes from the house of Axter.",
  },
  {
    id: "17",
    category: "Kids Section",
    image: "Bo_17",
    name: "Ben-10 Fashion Sandal",
    price: "456",
    description:
      "Material Type: Synthetic  Lifestyle: Casual Closure Type: Hook and loop Product warranty against manufacturing defects: 15 day",
  },
  {
    id: "18",
    category: "Kids Section",
    image: "Bo_18",
    name: "Axter Casual Stylish Sports Shoes ",
    price: "199",
    description:
      "Colour: Black Red-8100 Sole: Synthetic Closure: Hook & Loop Shoe Width: Medium Breathable and comfortable: The boys shoes with air mesh fabric upper can offers ultra-lightweight support",
  },
  {
    id: "19",
    category: "Kids Section",
    image: "Bo_19",
    name: "Lpmxt-833 Clog",
    price: "990",
    description:
      "ole: Ethylene Vinyl Acetate Closure: Pull On Shoe Width: Medium Multi-Use:You can use the shoes for house slippers when you relaxing in you home,you can wear this shoes just go walk with your dog in the afternoon also.",
  },
  {
    id: "20",
    category: "Kids Section",
    image: "Bo_20",
    name: "Softy Walking Shoes   ",
    price: "628",
    description:
      "Closure: Pull OnShoe Width: Regular Outer Material: Synthetic Closure Type: Slip On  Toe Style: Round Toe Warranty Description: 90 days",
  },
  {
    id: "21",
    category: "Kids Section",
    image: "Gi_1",
    name: "Ethnos Fashion Lehanga Choli",
    price: "699",
    description:
      "•	Care Instructions: Hand Wash Only •	Fit Type: Regular •	Care Instructions: Hand Wash Only •	Lengha Details: Type: Semi-stitched. Fabric: Tafetta silk. •	Blouse details: Type: Unstitched. Fabric: Taffeta silk.•	Work: embroidered",
  },
  {
    id: "22",
    category: "Kids Section",
    image: "Gi_2",
    name: "Banglori Satin with Net Lehenga Choli",
    price: "809",
    description:
      "•	Care Instructions: Dry Clean Only•	Material: Satin  •	Closure Type: Drawstrings  •	Sleeve Type: Half  •	Color: Green  ",
  },
  {
    id: "23",
    category: "Kids Section",
    image: "Gi_3",
    name: "Suppar Sleave Lehanga Choli",
    price: "499",
    description:
      "•	Care Instructions: Dry Clean Only•	Fabric: Choli –Banglori Satin with Digital Print| Lehenga: Nylon Net | Inner line-Ultra Satin | Dupatta-Net with Frill•	Closure Type: Elastic •	Sleeve Type: Sleeveless •	Age Range: Available for age 3-14 Years Girl’s, for correct size selection we recommend to refers images which has Size chart prior to placing order.•	Wash Care: Both gently hand wash and dry-clean are recommended. Use mild detergent and hang dry, but do not bleach.",
  },
  {
    id: "24",
    category: "Kids Section",
    image: "Gi_4",
    name: "Jacquard and Crepe Indo Western Style",
    price: "809",
    description:
      "•	Fabric: Lehenga & Choli-Jacquard Silk | Jacket- Crep •	Closure Type: Elastic for lehenga and Drawstring for Jacket •	Sleeve Type: Quarter Sleeve, Neck style: Mandarin Collar •	Age Range: Available for age 3-14 Years Girl’s, for correct size selection",
  },
  {
    id: "25",
    category: "Kids Section",
    image: "Gi_5",
    name: "A.R.K. DRESSES Maxi Dress",
    price: "399",
    description:
      "•	Care Instructions: Machine Wash•	Fit Type: Regular•	Fabric : Sarina print Lenin Blend; Closure :Belt Closure and Durable fabric and Durable color•	Wash Care : Cold and Easy Wash , Gentle Wash•	Type : Maxi/Full Length , Regular Fit•	The actual product may differ slightly in color from the one illustrated in the images. Guide: Please Refer Size Chart For Better Fitting•	Sleeve Type: Half Sleeve; Occasion Type: Casual",
  },
  {
    id: "26",
    category: "Kids Section",
    image: "Gi_6",
    name: "Flare Ball Gown Style Frock/Dress",
    price: "699",
    description:
      "•	Care Instructions: Hand Wash Only•	Fit Type: Relaxed•	Fabric: 100% Crepe•	Pattern: Solid Flare Layer•	Neck Style: Square Neck, Occasion: Dresses great for everyday casual or special occasions such as parties, holidays, birthdays, weddings, & photo shoots.Wash Care: Gently Hand wash/Cold Water wash/Dry clean only/Machine W",
  },
  {
    id: "27",
    category: "Kids Section",
    image: "Gi_7",
    name: "Girl's Regular T-Shirt",
    price: "508",
    description:
      "•	Crew neck tee•	Soft & Comfortable •	label free comfort •	Attractive colors and designs •	comes in a handy pack of 3",
  },
  {
    id: "28",
    category: "Kids Section",
    image: "Gi_8",
    name: "BTS Printed T-Shirt",
    price: "529",
    description:
      "•	Care Instructions: Machine Wash•	Material - Pure Cotton, Pattern - Printed, Sleeves - Half Sleeves, Pack Of 1 T-Shirt •	STYLE POINT : Our T-shirts gives a trendy yet Casual look. Durable stitching and Quality finish makes this Product a must have this Season.",
  },
  {
    id: "29",
    category: "Kids Section",
    image: "Gi_9",
    name: "Wommaniya Impex Crop top",
    price: "599",
    description:
      "•	Care Instructions: Dry Clean Only •	Fit Type: Regular Fit•	Top Fabric-Cotton•	Work-Multi Embroidery Designer•	Best Suitable for Casual, festival and Summer Dress",
  },
  {
    id: "30",
    category: "Kids Section",
    image: "Gi_10",
    name: "DALSI Girls Terry Cotton Crop Tops",
    price: "499",
    description:
      "•	Care Instructions: Hand Wash Only•	Fit Type: regular_fit•	Product Material: Terry Cotton, Color- White & Black, Fit Type: Regular Fit•	Solid full sleeve crop top with round neck. Composed of a durable soft fabric",
  },

  {
    id: "31",
    category: "Kids Section",
    image: "Gi_11",
    name: "girls Pajama Bottom",
    price: "149",
    description:
      "•	Material composition:100% Cotton•	Super combed Cotton printed fabric  •	Ultrasoft and durable waistband with drawstring  •	Convenient side pockets with lace trim  •	Relaxed fit",
  },
  {
    id: "32",
    category: "Kids Section",
    image: "Gi_12",
    name: "ARIEL Ankle Leggings",
    price: "274",
    description:
      "•	Fit Type: Regular•	Fabric: Fabric: 100% Cotton  •	Pattern: Printed  •	Opacity: Non-Transparent  •	Elasticated waist band for better adjustments  •	Age Range Description: Kid, Pocket Description: Without Pocket, Rise Style: Mid ",
  },
  {
    id: "33",
    category: "Kids Section",
    image: "Gi_13",
    name: "Chromozome Girl's Loose Pants",
    price: "372",
    description:
      "•	Care Instructions: Machine Wash •	Fit Type: Loose  •	Style MS 10 , Fit - Palazzo•	These fabulous pants are made with premium Polyamide Lurex Stretch fabric•	The Black base with blue lurex gives a dual tone to this fabric  •	This super soft fabric has beautiful drape which enhances the style",
  },
  {
    id: "34",
    category: "Kids Section",
    image: "Gi_14",
    name: "CHEROKEE Track pants",
    price: "567",
    description:
      "Care Instructions: Machine Wash Fit Type: Regular  GIRLS TRACKPANT",
  },
  {
    id: "35",
    category: "Kids Section",
    image: "Gi_15",
    name: "Jam & Honey Sports Shoes Sneaker    ",
    price: "615",
    description:
      "•	Sole: Rubber •	Closure: Pull On  •	Shoe Width: Medium  •	Easy to wear shoes  •	Soft Eva outsole  •	Comfortable Mesh upper  •	Soft cushioned insole",
  },
  {
    id: "36",
    category: "Kids Section",
    image: "Gi_16",
    name: "Arete Slipper Flipflops",
    price: "399",
    description:
      "•	Sole: Rubber•	Closure: Pull On  •	Shoe Width: Medium  •	Comfortable for Daily wear  •	Light weight and durable slipper",
  },
  {
    id: "37",
    category: "Kids Section",
    image: "Gi_17",
    name: "ACOSTAR Designer Sandal  ",
    price: "495",
    description:
      "•	Sole: Polyurethane •	Closure: Slip On •	Shoe Width: Medium •	ANTI FALL: Extremely Active and Smart provides endless comfort and sturdiness your child will never fall Soft sole guaranteed slip resistance;",
  },
  {
    id: "38",
    category: "Kids Section",
    image: "Gi_18",
    name: "Barbie Girl's Sneakers",
    price: "699",
    description:
      "•	Shoe Width: Regular •	Closure Type: Slip On •	Toe Style: Round Toe",
  },
  {
    id: "39",
    category: "Kids Section",
    image: "Gi_19",
    name: "United Colors of Benetton Flipflops",
    price: "299",
    description:
      "•	Sole: Ethylene Vinyl Acetate•	Closure: Pull On•	Shoe Width: Regular•	Outer Material: EVA•	Closure Type: Slip On•	Toe Style: Round Toe",
  },
  {
    id: "40",
    category: "Kids Section",
    image: "Gi_20",
    name: "BOOMER CUBS Floral Printed Sandals",
    price: "221",
    description:
      "•	Heel Height: 1 centimeters•	Shoe Width: Medium•	Available in Great Color selection; Easy to wear & Comfort to walk•	Suitable in every weather & on every outfits•	Airy from inside and comfortable insole  •	Set up your style game with the sandals for kids girls.  •	Toe Style: Open Toe",
  },
  {
    id: "41",
    category: "Grocery",
    image: "Gr_1",
    name: "Aashirvaad Arhar/Tur Dal Pouch",
    price: "173/kg",
    description:
      "our range of organic products have been expertly sourced and hygienically packed so that you get great taste and nutrition at aashirvaad we take pride in ensuring our consumers get quality products",
  },
  {
    id: "42",
    category: "Grocery",
    image: "Gr_2",
    name: "Tata Sampann Masoor Dal",
    price: "135/kg",
    description:
      " Rich in Nutrients: Masoor Dal is naturally rich in protein and high in dietary fibre Unpolished: Does not undergo any artificial polishing with water, oil or leather thereby retaining its goodness and wholesomeness",
  },
  {
    id: "43",
    category: "Grocery",
    image: "Gr_3",
    name: "Dhara Life Refined Ricebran Oil Jar",
    price: "1395",
    description:
      "Fortified 100 percent veg Super Saver pack  Cholesterol and Trans Fat Free",
  },
  {
    id: "44",
    category: "Grocery",
    image: "Gr_4",
    name: "Amul Taza",
    price: "63 ",
    description:
      "Amul Milk is the most hygenic liquid milk  Amul milk meets the PFA standards  Making of : Tea or Coffee, Sweets, Khoa, Curd, Buttermilk, Ghee ",
  },
  {
    id: "45",
    category: "Grocery",
    image: "Gr_5",
    name: "Eastern Super Garam Masala Powder",
    price: "37/100g",
    description:
      "No Artificial Colours No Added Preservatives Fresh And 100% Natural An unique blend of rich and premium spices.",
  },
  {
    id: "46",
    category: "Grocery",
    image: "Gr_6",
    name: "Nestle EVERYDAY Powder for Tea",
    price: "50.75 / 100g",
    description:
      "Get a thicker & tastier cup of tea every time with EVERYDAY powder Nestle Everyday Dairy Whitener ranked No. 1 by consumers in blind taste tests  Comes with added sugar to make the perfect cup of tea",
  },
  {
    id: "47",
    category: "Grocery",
    image: "Gr_7",
    name: "Fazalani Foods Basmati Rice",
    price: "49.67/ count",
    description:
      "Delicate fully rice from the Fazlani, known for Its tantalizing flavor and magical aroma No preservatives & no additives",
  },
  {
    id: "48",
    category: "Grocery",
    image: "Gr_8",
    name: "Sri Sri Tattva Organic Brown Sugar ",
    price: "143.99/ count",
    description:
      " Brown Sugar     Brown Sugar has a lower calorific value as compared to normal refined sugars",
  },
  {
    id: "49",
    category: "Grocery",
    image: "Gr_9",
    name: "Dry Fruit Hub Jaggery Cubes ",
    price: "249",
    description:
      "Dry Fruit Hub Jaggery Cubes fends off constipation by aiding digestion. It activates the digestive enzymes in our body, thus helps in proper digestion of food.It acts as a detox, as it helps cleanse the liver by flushing out nasty toxins from the body. It helps boost resistance against infections, hence building stronger immunity.",
  },
  {
    id: "50",
    category: "Grocery",
    image: "Gr_10",
    name: "Tata Salt",
    price: "20",
    description: "mental development of children",
  },
  {
    id: "51",
    category: "Grocery",
    image: "Gr_11",
    name: "Biteful Osmania Biscuits",
    price: "450",
    description:
      "Osmania just got more tasty : fresh from the bakers in Hyderabad straight to your door step. Premium quality biscuits.  Crispy and packed tight: we make sure that our biscuits reach your table without any breakage. Quality; quantity and affordability; the new tea time companion. item firmness description:Hard",
  },
  {
    id: "52",
    category: "Grocery",
    image: "Gr_12",
    name: "Britannia Bourbon ",
    price: "83",
    description:
      "A treasure for the lovers of chocolate packed between the surplus of crunch and sprinkled with delicate sugar crystals Smooth, melted chocolate fills your mouth with a sweet delighted taste for a mouth-watering experience",
  },
  {
    id: "53",
    category: "Grocery",
    image: "Gr_13",
    name: "Lay's American Style Potato Chips ",
    price: "10",
    description:
      "Delicious individual bags: perfect for snacking at work, home or school. 100% vegetarian, best quality potatoes, finest quality of spices and edible vegetable oils. Trans-fat free.",
  },
  {
    id: "54",
    category: "Grocery",
    image: "Gr_14",
    name: "Naturalz Kerala Banana Chips ",
    price: "235",
    description:
      "Store it in a cool ,dry place away from sunlight. Once opened keep it in a air tight container Ingredients:Banana (68%), Refined Palmolein Oil and Iodised salt (0.9%)",
  },
  {
    id: "55",
    category: "Grocery",
    image: "Gr_15",
    name: "Topizo Namkeen Tasty Peanut, Khatta Meetha Mixture, Pudina Chutni Bhujia, Ratlami Sev",
    price: "149.67/ count",
    description:
      "Topizo Namkeen Tasty Peanuts, Khatta Mitha Mixture, Pudina Chutney Bhujia (100% Tasty Indian Jhalmuri Namkeen) Pack of 3, 800g Perfect for Gift Celebrations Children Birthday Anniversary Chocolate Gift Party Snacks.",
  },
  {
    id: "56",
    category: "Grocery",
    image: "Gr_16",
    name: "Keya Special Soup Combo ",
    price: "57/count",
    description:
      "A true classic, keya’s sweet corn vegetable soup is made with super sweet american corn, spring onions and our signature range of premium herbs and seasonings",
  },
  {
    id: "57",
    category: "Grocery",
    image: "Gr_17",
    name: "Cadbury Silk Potli ",
    price: "620",
    description:
      "Share the joy with this scrumptious pack of goodness. An ideal gift for your friends & family Delicious gifting option of indulgent treats",
  },
  {
    id: "58",
    category: "Grocery",
    image: "Gr_18",
    name: "DR.RASHEL Goat Milk Cream ",
    price: "190",
    description:
      "Formulated using natural ingredients that do wonders to your skin Ideal For : Men & Women. 380 ml; APPLICATION AREA : Face & BodyMulti-vitamin rich, this cream breathes new life into your skin",
  },
  {
    id: "59",
    category: "Grocery",
    image: "Gr_19",
    name: "Epigamia Greek Yogurt",
    price: "47",
    description:
      "Low fat and high protein, delicious and thick Greek yogurt All natural No preservatives",
  },
  {
    id: "60",
    category: "Grocery",
    image: "Gr_20",
    name: "Nestle a+ Nourish Dahi",
    price: "65",
    description:
      "Undergoes 61 stringent quality checks to ensure high quality milk for your family. Undergoes unique flash heat treatment to preserve nutrients Toned Milk Fortified with Vitamin A&D.",
  },
  {
    id: "61",
    category: "Grocery",
    image: "Gr_21",
    name: "Cadbury 5 Star Chocolate ",
    price: "134",
    description:
      "A delicious indulgent combination of chocolate, caramel and nougat Long-lasting yummy chocolatey experience Country of Origin: India",
  },
  {
    id: "62",
    category: "Grocery",
    image: "Gr_22",
    name: "Amul Lassi",
    price: "16",
    description:
      "Amul kool Lassi is refreshing milk based natural drink Delicious taste  Tastes best when chilled",
  },
  {
    id: "63",
    category: "Grocery",
    image: "Gr_23",
    name: "Surf Excel Liquid Detergent",
    price: "395",
    description:
      "New Surf Excel matic liquid front load washing detergent gives you 100 percent stain removal in washing machines. Material Type Free: Fragrance Free",
  },
  {
    id: "64",
    category: "Grocery",
    image: "Gr_24",
    name: "Lizol Disinfectant Surface & Floor Cleaner ",
    price: "298",
    description:
      "Removes 100 types of Stains. Proven to kill 99.9% germs and viruses like H1N1 & RSV Leaves a Pleasant Fragrance",
  },
  {
    id: "65",
    category: "Grocery",
    image: "Gr_25",
    name: "HEM Aradhna Pooja Samagri",
    price: "238",
    description:
      "Contains: White Abhir, Gulal, Kumkum, Haldi, Camphor Tablets, Moli, Pooja Supari, Akhata, Agarbatti, Agarbatti Wooden Stand, Janvi Jod, Goddess Photo, Vastra (Pooja Cloth) & Dhoop.Performing daily pooja at the home creates a spiritual environment and improves the prosperity of the family.It also gives a good positive energy and purifies the body.",
  },
  {
    id: "66",
    category: "Grocery",
    image: "Gr_26",
    name: "Vedobi Havan Samagri",
    price: "319",
    description:
      "This Havan Samagri is a combination of rare medicinal and ayurvedic herbs. We have prepared this Havan Samagri from Ayurvedic herbs like loban, deodar, barley, black sesame Havan Samagri also purifies the environment besides activating the air which is disinfected by the germs.",
  },
  {
    id: "67",
    category: "Grocery",
    image: "Gr_27",
    name: "Red Label Natural Care Tea",
    price: "540",
    description:
      "Red Label Natural Care is a tasty masala tea with 5 ayurvedic ingredients such as ginger, tulsi, cardamom, mulethi & ashwagandha It has been clinically proven to enhance Immunity*",
  },
  {
    id: "68",
    category: "Grocery",
    image: "Gr_28",
    name: "Aashirvaad Select Sharbati Atta",
    price: "449",
    description:
      "Aashirvaad Shudh Chakki Atta is made using the 4-step advantage process which ensures 100% pure and natural whole wheat atta and retention of its natural dietary fibres and nutrients The 4-step advantage process of sourcing, cleaning, grinding and nutrition lockage ensures that the atta remains untouched by hands, thereby making the chakki atta safe",
  },
  {
    id: "69",
    category: "Grocery",
    image: "Gr_29",
    name: "Maggi 2-Minute Noodles ",
    price: "136",
    description:
      "Ready in 2 minutes, perfect meal for a hang out or house party Contains a noodle cake and the Favourite Masala Tastemaker inside, for a quick 2 minute preparation ",
  },
  {
    id: "70",
    category: "Grocery",
    image: "Gr_30",
    name: "EXOTES, California Almonds Vacuum Packed",
    price: "315",
    description:
      "Rich source of energy as it has got all the minerals, nutrients, antioxidants & vitamin Rich in beneficial nutrients.Good source of Vitamin E and omega-3 fats. Supports brain health.",
  },
  {
    id: "71",
    category: "Grocery",
    image: "Gr_31",
    name: "Vedaka Popular Almonds",
    price: "449",
    description:
      "Great Source of Antioxidants - Himalayan Natives premium quality Almonds are rich in antioxidants that can help reduce the effects of cell oxidation. This in turn may help reduce the risk of many diseases. Our almonds are also high in phytic acid, an antioxidant that binds certain minerals and prevents them from being absorbed",
  },
  {
    id: "72",
    category: "Grocery",
    image: "Gr_32",
    name: "Pediasure 7+ Specialized Nutrition Drink Powder ",
    price: "355",
    description:
      "Country of Origin: India Specialized flavour Delicious and Tasty ",
  },
  {
    id: "73",
    category: "Grocery",
    image: "Gr_33",
    name: "Vim Fresh Lemon Fragrance Dishwash Liquid Gel",
    price: "399",
    description:
      "It can safely be used to clean expensive crockery and cookware as it does not leave scratches.It has a superior fragrance that lasts long after rinsing utensils.It is soft on hands.",
  },
  {
    id: "74",
    category: "Grocery",
    image: "Gr_34",
    name: "Haldiram's Namkeen - Aloo Bhujia",
    price: "87",
    description: "This is a Vegetarian product Country of Origin: India",
  },
  {
    id: "75",
    category: "Grocery",
    image: "Gr_35",
    name: "Dabur Red Paste ",
    price: "200",
    description:
      "Dabur Red is India’s No. 1 Ayurvedic Fluoride Free Paste which is a complete Ayurvedic Oral Care for your family.It provides 35% betterment on oral care hygiene index in comparison to other regular toothpastes.",
  },
  {
    id: "76",
    category: "Grocery",
    image: "Gr_36",
    name: "Vanish All in One Powder Detergent Booster ",
    price: "175",
    description:
      "Use Vanish easily with both hand wash and machine wash, both direct and diluted. Add Vanish along with your detergent and get dry-clean like results for your everyday clothes in every wash Absolutely safe to use with both colored and white clothes.",
  },
  {
    id: "77",
    category: "Grocery",
    image: "Gr_37",
    name: "Tide Plus Double Power Detergent Washing Powder",
    price: "939",
    description:
      "Tide Plus Double Power is available in a range of amazing, iconic fragrances - Jasmine&Rose and Lemon&Mint Tide Plus Double Power is suitable for handwash and semi-auto washing machines",
  },
  {
    id: "78",
    category: "Grocery",
    image: "Gr_38",
    name: "Kissan Fresh Tomato Ketchup ",
    price: "200",
    description:
      "Made with premium ingredients which gives it a rich and superior taste without onion or garlic Blended with ripe vine bright red tomatoes giving it a smooth and thick texture",
  },
  {
    id: "79",
    category: "Grocery",
    image: "Gr_39",
    name: "Santoor Bath Soap ",
    price: "165",
    description:
      "Only Soap with Real Sandalwood Pure Sandal Soap Authentic Sandal Fragrance",
  },
  {
    id: "80",
    category: "Grocery",
    image: "Gr_40",
    name: "Catch Super Garam Masala Powder",
    price: "64",
    description:
      "RICH IN FLAVOUR: An exquisite blend of spices, Catch Super Garam Masala adds a distinct aroma, flavour, and colour to a variety of vegetarian and non-vegetarian dishes.",
  },
  {
    id: "81",
    category: "Pharmacy",
    image: "Pr_1",
    name: "Revital H ",
    price: "10 capsules Rs 95",
    description:
      "•	This nutritional capsule for daily health is a balanced combination of Ginseng, 10 Vitamins and 9 minerals which help in improving physical and mental performance and add vigor and vitality to everyday life •	Its key ingredients, natural Ginseng, vitamin B complex and Iron, help support daily energy needs, and fight fatigue throughout the day ",
  },
  {
    id: "82",
    category: "Pharmacy",
    image: "Pr_2",
    name: "Supradyn ",
    price: "15 tablets Rs 45",
    description:
      "•	 New Supradyn Daily boosts your energy and immunity – contains 12 vitamins, 5 trace elements, 2 minerals & 1 amino acid •	It contains Vit C, Vit D and even more Zinc now to enhance your immunity. Higher Zinc to help boost higher immunity ",
  },
  {
    id: "83",
    category: "Pharmacy",
    image: "Pr_3",
    name: "Whisper Choice Ultra ",
    price: "130",
    description:
      "•	Provides upto 100% stain protection•	It is 50mm longer (vs regular pads) and has a 20% wider back •	Dri-Weave top sheet that keeps you feeling clean and your skin dry ",
  },
  {
    id: "84",
    category: "Pharmacy",
    image: "Pr_4",
    name: "Sugar Free Gold",
    price: "265",
    description:
      "•	A boon to health conscious people & diabetics•	Ideal for adding to beverages •	Has negligible calories - Good for weight-watchers & diabetics",
  },
  {
    id: "85",
    category: "Pharmacy",
    image: "Pr_5",
    name: "Cadbury Bournvita ",
    price: "373.1",
    description:
      "•	The combination of calcium, vitamins and minerals helps multiply the power of milk•	It is a malted chocolate drink mix that can be enjoyed piping hot or deliciously cold",
  },
  {
    id: "86",
    category: "Pharmacy",
    image: "Pr_6",
    name: "Baidyanath Chyawanprash ",
    price: "252",
    description:
      "•	Dabur Chyawanprash boosts ability to fight illnesses*•	2 spoons of Dabur Chyawanprash daily help to keep your child protected •	It is 2 spoons of protection with good taste  •	Dabur Chyawanprash is a daily dose for your family to build Strength & Stamina ",
  },
  {
    id: "87",
    category: "Pharmacy",
    image: "Pr_7",
    name: "Protinex Mama ",
    price: "394.25",
    description:
      "•	Essential Nutrition during Pregnancy & Lactation•	With DHA - for foetus brain development •	Available in Delicious Flavours - creamy VANILLA and exquisite CHOCOLATE",
  },
  {
    id: "88",
    category: "Pharmacy",
    image: "Pr_8",
    name: "Horlicks Health & Nutrition Drink Jar, 500 G",
    price: "237.15",
    description:
      "•	Horlicks was first invented to substitute milk as baby food•	Horlicks, in India, has tied up with popular kids movies like Ice Age II and Superman Returns",
  },
  {
    id: "89",
    category: "Pharmacy",
    image: "Pr_9",
    name: "Complan",
    price: "265.88",
    description:
      "•	Complan is a nutrition and health drink with clinically proven formula to deliver 2 times faster growth•	Contains 100% First Class Protein•	Contains 34 Vital Nutrients ",
  },
  {
    id: "90",
    category: "Pharmacy",
    image: "Pr_10",
    name: "Vandelay Infrared Thermometer ",
    price: "1990",
    description:
      "•	Non Contact and Accurate Readings : Non-contact infrared measurement. Measuring distance is under 1-2inch, while avoiding cross infection. The forehead thermometer medical has been clinically tested, and has a very small error margin. It is actually more accurate and healthier than standard mercury thermometers.",
  },
  {
    id: "91",
    category: "Pharmacy",
    image: "Pr_11",
    name: "WOW Life Science Omega-3",
    price: "799",
    description:
      "•	Advanced delivery system for better absorption and to avoid fishy aftertaste•	Product Benefit: Energy Management. Container Type: Canister. Material Features: Dairy Free",
  },
  {
    id: "92",
    category: "Pharmacy",
    image: "Pr_12",
    name: "Accu-Chek",
    price: "1528.20",
    description:
      "•	Easy to use: Accu-Chek Active blood glucose meter packs many powerful features into a smaller size, making the blood glucose monitoring process easy.•	No coding required: Accu-Chek Active blood glucose meter is easy to use as it doesn’t require any code chip for coding the meter. ",
  },
  {
    id: "93",
    category: "Pharmacy",
    image: "Pr_13",
    name: "Dabur Odomos Narurals",
    price: "76",
    description:
      "•	Doesn't kill or knock down mosquitoes using deadly chemicals•	Uses a formula which masks the distinctive body odour that the human skin typically emits, making you virtually invisible to mosquitoes ",
  },
  {
    id: "94",
    category: "Pharmacy",
    image: "Pr_14",
    name: "Genone E-Gen",
    price: "180",
    description:
      "Vitamin E for Good for Skin and Hair : Vitamin E is Best health supplement for skin and hair which help boost hair growth as well as keep skin clean and free from acne. these capsules can be swallow directly or directly apply them on skin or hairs. WEXCARE vitamin E softgel capsules are perfectly edible and you can take 1 softgel capsule a day for good results.",
  },
  {
    id: "95",
    category: "Pharmacy",
    image: "Pr_15",
    name: "Dettol ",
    price: "184.87",
    description:
      "•	DISINFECTANT LIQUID: Protects from 100 illness causing germs •	AVAILABLE IN 2 FRAGRANCES: Fresh Lime and Menthol Cool ",
  },
  {
    id: "96",
    category: "Pharmacy",
    image: "Pr_16",
    name: "Mamaearth Anti Mosquito",
    price: "99",
    description:
      "100% NATURAL PROTECTION : Mamaearth's Fabric Roll On contains 100% natural mosquito repellent ingredients. Blend of Citronella, Eucalyptus & Lemongrass oil guards your family from mosquitoes",
  },
  {
    id: "97",
    category: "Pharmacy",
    image: "Pr_17",
    name: "Godrej Protekt Disinfectant Spray",
    price: "128",
    description:
      "Germ protection: provides protection against illness-causing germs and bacteria No grease, no odour: With performance cleansers - mild on hands but tough on grease",
  },
  {
    id: "98",
    category: "Pharmacy",
    image: "Pr_18",
    name: "Himalaya Liv.52",
    price: "144.5",
    description:
      "Country of Origin: India Indications: - Protects the liver against various hepatotaxins, corrects liver dysfunction and damage, promotes appetite and growth",
  },
  {
    id: "99",
    category: "Pharmacy",
    image: "Pr_19",
    name: "Zandu Pain Relief Balm ",
    price: "76.5",
    description:
      ". India's No. 1 and trusted ayurvedic balm with more than 100 years of expertise in pain relief•	The balm is non- greasy and penetrates swiftly into the affected areas to help deliver quick and long-lasting relief from pain. ",
  },
  {
    id: "100",
    category: "Pharmacy",
    image: "Pr_20",
    name: "Dabur Pudin Hara",
    price: "46.75",
    description:
      "Brand name: dabur Manufacturer : dabur india ltd  Pudin hara is 100% natural and safe, available as syrup, tablets, and antacid powder.",
  },
  {
    id: "101",
    category: "Pharmacy",
    image: "Pr_21",
    name: "Pampers New Baby Diaper",
    price: "327.6",
    description:
      "A flexible waistband means baby has the freedom to move in a snug and comfortable fit . Bubble Wala Huggies absorbs wetness up to 12 hours, so your baby stays dry overnight with no irritation or rashes",
  },
  {
    id: "102",
    category: "Pharmacy",
    image: "Pr_22",
    name: "Horlicks Mother'S Plus",
    price: "205.8",
    description:
      "•	Scientifically Designed Nutrition For Pregnancy And Lactation•	25 Vital Nutrients•	Protein For Healthy Birth Weight",
  },
  {
    id: "103",
    category: "Pharmacy",
    image: "Pr_23",
    name: "Saridon Headache Relief Tablet",
    price: "35.45",
    description:
      "•	Pain Relief Tablets•	Adults and Children aged 12 years and above: 1 tablet every 4-6 hours not exceeding 6 tablets in 1 day.",
  },
  {
    id: "104",
    category: "Pharmacy",
    image: "Pr_24",
    name: "Mumfer Max",
    price: "289",
    description:
      "•	Mumfer-max helps with nutritional support and is safe for expectant mothers and new mothers.•	Low hemoglobin can lead to pale skin and brittle nails, Mumfer-Max is a carefully curated blend with iron which helps in maintaining hemoglobin levels. ",
  },
  {
    id: "105",
    category: "Pharmacy",
    image: "Pr_25",
    name: "ZEROHARM HoloDiabetis",
    price: "400",
    description:
      "Our unique, patent-pending, encapsulation method, formulation process, and nanotechnology ensure 100% solubility and bioavailability of ingredients, thus offering higher efficacy and therapeutic action.",
  },
  {
    id: "106",
    category: "Pharmacy",
    image: "Pr_26",
    name: "Sukh Darshan High Top Flavor Vanilla Chlorophy",
    price: "341",
    description:
      "Helps to increase height naturally and its easy to consume with no side effects. Product Benefits	Energy Management",
  },
  {
    id: "107",
    category: "Pharmacy",
    image: "Pr_27",
    name: "Dr Ortho Pain Relief",
    price: "221",
    description:
      "Herbal formulation for body pain: achoo pain oil is a specially formulated ayurvedic formulation blended with medicinal herbal oils, that helps in releiving pain associated with muscles & joints pain of neck, shoulder, back, wrist, hip, knee & ankle ",
  },
  {
    id: "108",
    category: "Pharmacy",
    image: "Pr_28",
    name: "Indulekha Bringha Shampoo",
    price: "299",
    description:
      "•	. Clinically Proven to Grow Hair in 4 months, Reduces Hair Fall •	Power of 11 Herbs & Essential Oil cooked under Natural Sunlight for 7 days. ",
  },
  {
    id: "109",
    category: "Pharmacy",
    image: "Pr_29",
    name: "AAYURVEDYA Healthy Kidney Combo",
    price: "679",
    description:
      "•	PACKAGE CONTENTS: Dr Immune 60 Tabs, Dr Shuddhi Powder 100 gm, Rakt Chap Vati 60 Tabs, Uro Plus 60 Tabs, Divya DM 60 Caps, 32 Herbs Tea 30 gm•	HELPS SUPPORT KIDNEY: Supports healthy urinary tract and kidney function, Helps flush toxins, Encourages proper waste filtration in the kidneys, Naturally helps the kidneys flush waste.",
  },
  {
    id: "110",
    category: "Pharmacy",
    image: "Pr_30",
    name: "Himalaya Ashvagandha",
    price: "142",
    description:
      "•	Ashwagandha has been found to significantly increase white blood cells which thereby enhances immunity by strengthening the antibody function.•	Ashwagandha helps improve the overall sleep quality and maintains healthy sleep patterns.",
  },
  {
    id: "111",
    category: "Women's Section",
    image: "Wt_1",
    name: "Traditional Rajasthani Design front Embroidered Kutchi",
    price: "399",
    description: " Fit Type: regular_fit, Product is suitable for XS,S",
  },
  {
    id: "112",
    category: "Women's Section",
    image: "Wt_2",
    name: "Sunrise Paridhan Women's Cotton Dupatta - SPMIR07_Multicolour_Free Size",
    price: "325",
    description: "Colour: Black and yellow Traditional Rajasthani design",
  },
  {
    id: "113",
    category: "Women's Section",
    image: "Wt_3",
    name: "Women's Net Unstitched Lehenga Choli (Pink_Free Size)",
    price: "599",
    description: " Department Womens Manufacturer Vyani Creation Surat India",
  },
  {
    id: "114",
    category: "Women's Section",
    image: "Wt_4",
    name: "TILKI woman's Lengha choli set",
    price: "1240",
    description:
      "Fit Type: Overall Lehenga : Semi-stitched | Fabric : Taffeta silk",
  },
  {
    id: "115",
    category: "Women's Section",
    image: "Wt_5",
    name: "Applix Style Women's Kanjivaram Soft Silk Unstitched Lehenga Choli",
    price: "2499",
    description:
      " Colour: _Yellow_Pink Fit Type: Regular Material :- Lehenga :- Kanjivaram Soft Silk | (Waist - 44 inches, Height - 47 Inches) | Choli :- Banglori Soft Silk (0.8 Meters) | Dupatta :- Georgette Soft Silk (2.25 Meter)",
  },
  {
    id: "116",
    category: "Women's Section",
    image: "Wt_6",
    name: "RedRound Grey Printed Semi-Stitched Lehenga Choli",
    price: "2339",
    description:
      "Printed lehenga with choli V-neck Flared bottom Cotton, dry clean",
  },
  {
    id: "117",
    category: "Women's Section",
    image: "Wt_7",
    name: "Sangria Women Black Embellished Sequinned Heavy Work Saree",
    price: "1709",
    description:
      "Saree fabric: Pure Georgette Blouse fabric: Silk Cotton Dry clean",
  },
  {
    id: "118",
    category: "Women's Section",
    image: "Wt_8",
    name: "Saree mall Pink & Blue Floral Dyed Banarasi Sarees",
    price: "1462",
    description:
      " Size & Fit Length: 5.5 metres plus 0.8 metre(80 cm) blouse piece Width: 1.06 metres ",
  },
  {
    id: "119",
    category: "Women's Section",
    image: "Wt_9",
    name: "GoSriKi Women's Cotton Straight Kurta with Palazzo & Dupatta ",
    price: "649",
    description:
      " Kurta Fabric: Cotton Blend This three piece set includes kurta,Palazzo and dupat",
  },
  {
    id: "120",
    category: "Women's Section",
    image: "Wt_10",
    name: "Janasya Indian Women's Tunic Tops Crepe Kurti for Wome",
    price: "2142",
    description:
      " Hand Wash Only Material: Poly Crepe Style: A-line 50 length Kurta with 3/4 Sleeve",
  },
  {
    id: "121",
    category: "Women's Section",
    image: "Wt_11",
    name: "Janasya Indian Women's Tunic Tops Crepe Kurti for Women",
    price: "1842",
    description:
      " Kurta Material:Poly Crepe Style: High Low 48 length Kurta with Roll-up Sleeve",
  },
  {
    id: "122",
    category: "Women's Section",
    image: "Wt_12",
    name: "CHARTOU Women's Premium Metallic Shiny Shimmer Accordion Pleated Long Maxi Skirt",
    price: "2500",
    description:
      "Stretched high waist, Pull on closure Shiny metallic long maxi beach skirt with pleats ",
  },
  {
    id: "123",
    category: "Women's Section",
    image: "Wt_13",
    name: "Indian Pakistani Party Wear Wedding Wear Anarkali Gown Suit for Women LT2",
    price: "4500",
    description: " ||Customize Stitch ||Unstitch",
  },
  {
    id: "124",
    category: "Women's Section",
    image: "Wt_14",
    name: "Afibi Boho Floral Long Summer Beach Chiffon Wrap Cover Up Maxi Skirt for Women",
    price: "2999",
    description: "Department Womens",
  },
  {
    id: "125",
    category: "Women's Section",
    image: "Wf_1",
    name: "PUMA Women's Laguna Fusion Sport Golf Shoe",
    price: "2999",
    description:
      " The Fusion of style and performance. From the course to the clubhouse the Laguna Fusion Sport will keep your style on point and your feet feeling sporty and fabulous",
  },
  {
    id: "126",
    category: "Women's Section",
    image: "Wf_2",
    name: "ALEADER Women's Energycloud Lightweight Slip On Walking Running Shoes",
    price: "2149",
    description:
      " : Stretchy, comfort foot-hugging knit offer the breathability&flexibility",
  },

  {
    id: "127",
    category: "Women's Section",
    image: "Wf_3",
    name: "DUOYANGJIASHA Women's Athletic Road Running Mesh Breathable Casual Sneakers Lace Up Comfort Sports Student Fashion Tennis Shoes",
    price: "3999",
    description:
      " Super Breathable & Comfortable Upper  Anti-slip & Durable Sole: high-quality EVA sole,",
  },

  {
    id: "128",
    category: "Women's Section",
    image: "Wf_4",
    name: "Clarks Women's Breeze Sea    ",
    price: "999",
    description: "  EVA midsole lightweight Cloudsteppers flip flop",
  },

  {
    id: "129",
    category: "Women's Section",
    image: "Wf_5",
    name: "Three-Zone Comfort with Orthotic Insole Arch Support, Sandals for Women, Flip Flops",
    price: "500",
    description: "  the dual layer Leather Aloe striking O-Ring embellishment",
  },

  {
    id: "130",
    category: "Women's Section",
    image: "Wf_6",
    name: "vivianly Clear Pointed Toe Sandals Stiletto Heels Transparent Strap High Heels Slip on Mules for Women",
    price: "1142",
    description:
      " Material :TPU Upper, PU leather insole and Non-slip rubber sole.",
  },

  {
    id: "131",
    category: "Women's Section",
    image: "Wf_7",
    name: "LifeStride Women's Charlotte Heeled Sandal",
    price: "2599",
    description:
      " Open Pointed toe Sandals Heels High: 3.5in (approx). Platform height: 0.39in (approx). ",
  },

  {
    id: "132",
    category: "Women's Section",
    image: "Wf_8",
    name: "vivianly Pointed Toe Slingback Sandals Ankle Strap Heeled Sandals Wedding Dress Stiletto High Heels for Women",
    price: "500",
    description: "square toe ankle strap sandals ",
  },

  {
    id: "133",
    category: "Women's Section",
    image: "Wf_9",
    name: "Clarks Women's Emslie Lulin Pump",
    price: "765",
    description: "A low, chunky heel boosts ",
  },

  {
    id: "134",
    category: "Women's Section",
    image: "Wf_10",
    name: "Sivellya Womens Ankle Boots Fashion Stylish Comfortable Buckled Boots Wide Width Round Toe Low Heel Bootie Grey Brown",
    price: "1200",
    description:
      " Sivellya shoes feature flexible and skid resistant soles, stable heels and padded insoles",
  },
  {
    id: "135",
    category: "Men's Section",
    image: "Me_1",
    name: "Tathastu Mens Sherwani Kurta Pyjama Set",
    price: "1190",
    description:
      " Tathastu Mens Sherwani Kurta Pyjama Set ,Size :- Select Actual Measurement of your Bare Chest",
  },
  {
    id: "136",
    category: "Men's Section",
    image: "Me_2",
    name: "ONTTNO Men's Loose Stretchy Waist Casual Ankle Length Pants",
    price: "2999",
    description: " Baggy, ankle length, Tropical and vintage ,Length:104cm0.9",
  },
  {
    id: "137",
    category: "Men's Section",
    image: "Me_3",
    name: "Wehilion Vest Pant Men 2 Pieces Dress Suit Vest Pant Set Slim Fit Casual Suit Waistco",
    price: "2500",
    description:
      "Color: Black, Button closure SUPERIOR MATERIAL-70% Polyester and 30% Viscose",
  },
  {
    id: "138",
    category: "Men's Section",
    image: "Me_4",
    name: "YFFUSHI Men's Slim Fit 3 Piece Suit One Button Business Wedding Prom Suits Blazer Tux Vest & Trousers",
    price: "4999",
    description:
      " Color: Dark Grey Button closure SUPERIOR MATERIAL-70% Polyester and 30% Viscose",
  },
  {
    id: "139",
    category: "Men's Section",
    image: "Me_5",
    name: "MLANM Mens Casual Slim Fit Basic Henley Short/Long Sleeve Fashion Cotton T-Shirt",
    price: "500",
    description: " Color: B3 White ,Material: 95% Cotton, 5% Spandex",
  },
  {
    id: "140",
    category: "Men's Section",
    image: "Me_6",
    name: "LEOTUDE Regular Fit Full Sleeve Men's T-Shirt",
    price: "299",
    description:
      " Colour: Navy Fabric: Cotton Blend Neck Style: Round Neck Pattern : Striped;  Collar Style: Classic Collar",
  },
  {
    id: "141",
    category: "Men's Section",
    image: "Me_7",
    name: "Dennis Lingo Men's Classic Collar Casual Shirt",
    price: "439",
    description:
      " Colour: Dusty Pink Fit Type: slim fit Color Name: Bottle Green Long sleeve",
  },
  {
    id: "142",
    category: "Men's Section",
    image: "Me_8",
    name: "Maniac Men's Cargo Black Cotton Jogger",
    price: "849",
    description:
      " Fit Type: Slim Size Guide : MEDIUM(30-32),LARGE(32-34),X-LARGE(34-36) Color: Black",
  },
  {
    id: "143",
    category: "Men's Section",
    image: "Me_9",
    name: "Peppyzone Men's Camouflage Regular Fit Track Pant",
    price: "499",
    description:
      "Color: Green 100% Cotton Camouflage Printed Fabric Stylish design with convertible waistline and pockets. Looks great with a jacket",
  },
  {
    id: "144",
    category: "Men's Section",
    image: "Me_10",
    name: "Levi's Men's 512 Regular Fit Chino Jeans",
    price: "1190",
    description: "Color: Green ",
  },
  {
    id: "145",
    category: "Men's Section",
    image: "Me_11",
    name: "Merrell Men's Moab 2 Vent Hiking Shoe",
    price: "2999",
    description: " Color: Walnut Performance suede leather and mesh upper",
  },
  {
    id: "146",
    category: "Men's Section",
    image: "Me_12",
    name: "Breathable mesh lining. 5mm lug depth",
    price: "1500",
    description: " Color: Walnut Performance suede leather and mesh upper",
  },
  {
    id: "147",
    category: "Men's Section",
    image: "Me_13",
    name: "TFO Hiking Shoes Men Waterproof Air Circulation Insole Ankle Support Non-Slip Lightweight for Outdoor Trekking Walking",
    price: "3000",
    description: "Color: Blue",
  },
  {
    id: "148",
    category: "Men's Section",
    image: "Me_14",
    name: "OOFOS Unisex OOCloog - Lightweight Recovery Footwear - Reduces Pressure on Feet, Joints & Back - Machine Washable",
    price: "500",
    description: "Color: Black ,Shoe Type: Sandal",
  },
  {
    id: "149",
    category: "Men's Section",
    image: "Me_15",
    name: "Under Armour Men's Ansa Fix Slide Sandal",
    price: "399",
    description:
      " Color: Black/White/White Shaft measures approximately low-top from arch Platform measures approximately 0-3 inches ",
  },
  {
    id: "150",
    category: "Men's Section",
    image: "Me_16",
    name: "PUMA Men's Ignite Fasten8 Golf Shoe",
    price: "299",
    description: " Color: Puma White-puma Silver-high Rise",
  },
  {
    id: "151",
    category: "Women's Section",
    image: "Ww_1",
    name: "DouBCQ Womens Summer Romper Casual Short Jumpsuits with Pockets",
    price: "1420",
    description:
      " tem Style:Sweet/Cute/Casual/Stylish. Item Sleeve: Sleeveless, Short sleeve, Spaghetti Strap.",
  },
  {
    id: "152",
    category: "Women's Section",
    image: "Ww_2",
    name: "luvamia Women's Casual Short Sleeve Belted Overlay Keyhole Back Jumpsuits Romper",
    price: "1999",
    description: "Color:  Black Material: 95% Polyester / 5% Spandex    ",
  },
  {
    id: "153",
    category: "Women's Section",
    image: "Ww_3",
    name: "Floerns Women's Casual Boho Ruffle Long Bell Sleeve Tops Tee Shirt",
    price: "599",
    description: " Color: Baby Blue, Fabric is stretchy, soft and comfy ",
  },
  {
    id: "154",
    category: "Women's Section",
    image: "Ww_4",
    name: "Dressystar Women's V Neck Sleeveless Lace Bridesmaid Dress Wedding Party Gown",
    price: "2500",
    description:
      "Color: Burgundy, Fabric: Lace and chiffon, comfortable and soft touch. ",
  },
  {
    id: "155",
    category: "Women's Section",
    image: "Ww_5",
    name: "The Drop Women's Gabriela High Neck Cut-In A-Line Side Slit Maxi Sweater Dress",
    price: "999",
    description: " Color: Black     ",
  },
  {
    id: "156",
    category: "Women's Section",
    image: "Ww_6",
    name: "We1Fit Women's Jogger Sweatpants High Waisted Loose Fit Athletic Gym Pants with Pockets",
    price: "499",
    description:
      " $16.99 Color: White Ultra Soft Material: Our sweatpants are made of premium cotton fabric, soft and skin-friendly, ",
  },
  {
    id: "157",
    category: "Women's Section",
    image: "Ww_7",
    name: "Libin Women's Cargo Joggers Lightweight Quick Dry Hiking Pants Athletic Workout Lounge Casual Outdoor",
    price: "899",
    description:
      "$32.98 , Fabric is super lightweight, slightly elastic, quick dry and comfortable ",
  },
  {
    id: "158",
    category: "Women's Section",
    image: "Ww_8",
    name: "Hotouch Womens Flannel Plaid Shirts Roll Up Long Sleeve Pockets Mid-Long Casual Boyfriend Shirts",
    price: "699",
    description: " Color: Black",
  },
  {
    id: "159",
    category: "Women's Section",
    image: "Ww_9",
    name: "Hotouch Womens Cotton Linen Shirts Roll-Up Sleeve Button Down Shirt Summer Casual Long Sleeve V Neck Solid Blouse",
    price: "499",
    description: "  - Cotton Linen Long Sleeve Shirts with sleeve tabs",
  },
  {
    id: "160",
    category: "Women's Section",
    image: "Ww_10",
    name: "SheIn Women's Two Piece Open Front Long Sleeve Blazer and Elastic Waist Solid Pant Set Suit",
    price: "3999",
    description:
      "Color: Burgundy ,Medium Pull On closure, Fabric: 95% Polyester, 5% Spandex. Fabric has some stretch ",
  },
]

export default Data
